import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ProductName } from './ProductName';
import { checkoutUrl, trackCheckout } from '../utils/checkout';
import { mainMockup } from '../data/media';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="bg-cream px-4 pb-8 pt-5 sm:pb-10 sm:pt-7" data-id="element-124" data-mp="4mi2n8mfxkdf">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-125" data-mp="4jvyliyrdmzy">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="flex flex-col items-center" data-id="element-126" data-mp="127eereur1rdz">
          <ProductName className="text-2xl leading-none sm:text-3xl" data-id="element-127" data-mp="sd4aozwg34nf" />
          <span className="mt-3 h-px w-16 bg-champagne-deep" aria-hidden="true" data-id="element-128" data-mp="nboo33emcq2x" />
          <h1 className="mt-3 max-w-4xl font-serif text-[2.1rem] font-semibold leading-[1.08] text-espresso sm:text-5xl lg:text-[3.4rem]" data-id="element-129" data-mp="3czfkfwx3o34z">
            Solve Months of Pastry Class Planning in Just{' '}
            <span className="text-raspberry" data-id="element-130" data-mp="3j6fvvj9ob1ao">5 Minutes</span>
          </h1>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} src={mainMockup} alt="Pastry Instructor Ready: class finder tablet, 6 complete volumes, 5 bonus guides and 150 ready-to-teach lessons" className="mt-4 h-auto max-h-[38vh] w-auto max-w-full object-contain drop-shadow-xl sm:mt-5 sm:max-h-[46vh]" data-id="element-131" data-mp="3o5j3nbh1flmc" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} className="mt-4 flex flex-col items-center sm:mt-5" data-id="element-132" data-mp="2qkwk90l5rzv6">
          <p className="max-w-3xl text-sm leading-6 text-cocoa sm:text-base" data-id="element-133" data-mp="2hjym2yxeimki">
            The Complete <strong className="text-raspberry" data-id="element-134" data-mp="2ljz22o05f5to">6-in-1</strong>{' '}
            Visual Teaching System with{' '}
            <strong className="text-raspberry" data-id="element-135" data-mp="s44itpsj1piy">150 Ready-to-Teach</strong>{' '}
            Pastry Lessons, 6 Complete Volumes and 5 Professional Bonus Guides —
            Ready to Open and Use with Your Students.
          </p>
          <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.16em] text-espresso sm:text-xs" data-id="element-136" data-mp="ddf2k907lk88">
            <span className="text-raspberry" data-id="element-137" data-mp="1b1ffr3qos6v8">100% Visual</span> · Beginner to
            Advanced · Ready to Teach
          </p>
          <div className="mt-4 sm:mt-5" data-id="element-138" data-mp="16346au4azydj">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} data-id="element-139" data-mp="15zzupboie0cu">
              GET PASTRY INSTRUCTOR READY NOW
            </Button>
          </div>
          <p className="mt-3 text-xs font-medium text-cocoa sm:text-sm" data-id="element-140" data-mp="3lsp3hdsd4jef">
            Immediate Access · One-Time Payment · 7-Day Guarantee
          </p>
        </motion.div>
      </div>
    </section>;
}